import type { PluginIconPlugin } from "@product/components/content/plugin-icon";
import type { RunSourceUsage } from "@product/lib/run-source-usage";

import { ANSWER_MARKDOWN, ANSWER_RECORD_IDS, QUESTION, SAMPLES } from "./fixture";
import { RUN, RUN_PLUGINS, RUN_SOURCES } from "./fixture-run";
import { ostreySheetRecord, type ShotSheetRecord } from "./sheet-record";
import { OSTREY_TURN_TIMES, OSTREY_WORKSPACE, type ShotTurnTimes, type ShotWorkspace } from "./workspace";

/**
 * One finished session a shot tells: the workspace around it, the question
 * and its answer, the records the answer links (in reading order, the
 * record sheet's previous and next), the closed run trace and the sources
 * beneath the answer. Plain data, so a server-rendered first frame can hand
 * it to the interactive shot.
 */
export type ShotStory = {
  workspace: ShotWorkspace;
  question: string;
  answerMarkdown: string;
  times: ShotTurnTimes;
  records: ShotSheetRecord[];
  /** The closed trace pill. Only a run whose events the shot carries opens
   *  its trace. */
  trace: { label: string; durationLabel: string | null; openable: boolean };
  /** The sources beneath the answer, when the run's use of them is known. */
  provenance: { sources: RunSourceUsage[]; plugins: PluginIconPlugin[] } | null;
};

/** The kettle comparison in Ostrey Home. */
export const OSTREY_STORY: ShotStory = {
  workspace: OSTREY_WORKSPACE,
  question: QUESTION,
  answerMarkdown: ANSWER_MARKDOWN,
  times: OSTREY_TURN_TIMES,
  records: ANSWER_RECORD_IDS.map((id) => ostreySheetRecord(SAMPLES.find((sample) => sample.id === id)!)),
  trace: { label: RUN.label, durationLabel: RUN.durationLabel, openable: true },
  provenance: { sources: RUN_SOURCES, plugins: RUN_PLUGINS },
};
